<template>
  <div class="template-single-video mb-5">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <MaterialHeader :content="content"/>
          <h2 class="text-primary bold mb-2 material-title"
              v-html="content.title.rendered"></h2>
          <p class="material-subtitle text-secondary">{{content.acf.subtitle}}</p>
          <div class="introduction mb-5 pt-3" v-if="content.acf.introduction.text">
            <div class="d-flex justify-content-start align-items-start align-items-md-center">
              <img v-if="content.acf.introduction.icon" :src="content.acf.introduction.icon" class="icon">
              <p class="m-0" v-html="content.acf.introduction.text"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="video-wrapper">
      <b-aspect aspect="16:9">
        <div class="video-holder" v-html="content.acf.video"></div>
      </b-aspect>
    </div>
  </div>
</template>

<script>
import MaterialHeader from '@/templates/template-parts/MaterialHeader.vue';

export default {
  props: {
    content: Object,
  },
  components: {
    MaterialHeader,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.template-single-video {
  .video-holder {
    height: 100%;
    ::v-deep iframe {
      width: 100%;
      height: 100%;
    }
  }
  .material-subtitle {
    font-size: 25px;
  }
  @include media-breakpoint-down(lg) {
    .material-title {
      font-size: 24px;
    }
    .material-subtitle {
      font-size: 20px;
    }
  }
  .introduction {
    img {
      width: 100%;
      max-width: 65px;
      margin-right: 25px;
    }
  }
  .introduction {
    font-size: 16px;
  }
}
</style>
